import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useAdminAdventPass = () => {
  return useQuery({
    queryKey: ["admin-advent-pass"],
    queryFn: async () => {
      // First get the ADVENTPASS partner code ID
      const { data: partnerCode, error: codeError } = await supabase
        .from("partner_codes")
        .select("id")
        .eq("code", "ADVENTPASS")
        .maybeSingle();

      if (codeError) {
        console.error("Error fetching ADVENTPASS code:", codeError);
        throw codeError;
      }

      if (!partnerCode) {
        console.log("ADVENTPASS code not found");
        return [];
      }

      // Fetch redemptions for ADVENTPASS
      const { data: redemptions, error: redemptionsError } = await supabase
        .from("partner_code_redemptions")
        .select("id, redeemed_at, credits_granted, user_id")
        .eq("partner_code_id", partnerCode.id)
        .order("redeemed_at", { ascending: false });

      if (redemptionsError) {
        console.error("Error fetching redemptions:", redemptionsError);
        throw redemptionsError;
      }

      if (!redemptions || redemptions.length === 0) {
        console.log("No redemptions found");
        return [];
      }

      // Fetch user profiles for all redemptions
      const userIds = redemptions.map(r => r.user_id);
      const { data: profiles, error: profilesError } = await supabase
        .from("profiles")
        .select("id, first_name, last_name, email, phone")
        .in("id", userIds);

      if (profilesError) {
        console.error("Error fetching profiles:", profilesError);
        throw profilesError;
      }

      // Combine the data
      const combinedData = redemptions.map(redemption => {
        const profile = profiles?.find(p => p.id === redemption.user_id);
        return {
          id: redemption.id,
          redeemed_at: redemption.redeemed_at,
          credits_granted: redemption.credits_granted,
          user_id: redemption.user_id,
          profiles: profile || null
        };
      });

      console.log("Advent Pass data fetched:", combinedData);
      return combinedData;
    },
  });
};
